
import CircularProgress from "../../../../componentsNew/CircularProgress";
import Typography from "../../../../componentsNew/Typography";

function CarregamentoAnalise({ tipoAnalise, tipoLegibilidade }) {
    return (
        <>
            {!tipoAnalise &&
                <div key={1} className="flex items-center justify-center flex-col">
                    <div>
                        <CircularProgress className="mt-6" component="grande"/>
                    </div>
                    <Typography className="mt-1">
                        Analisando {tipoLegibilidade}...
                    </Typography>
                </div>
            }
            {/* {tipoAnalise &&
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'unset', justifyContent: 'flex-start', ml: .5 }}>
                    <Box>
                        <CircularProgress color="success" size={20} />
                    </Box>
                    <Typography sx={{ ml: 2 }} color={'#203C42'} fontSize={'.75rem'} fontWeight={700}>
                        Analisando
                        {tipoAnalise === TIPO_ANALISE.UsoVirgula && ' uso da virgula...'}
                        {tipoAnalise === TIPO_ANALISE.VozPassiva && ' voz passiva...'}
                        {tipoAnalise === TIPO_ANALISE.Gramatica && ' gramática...'}
                        {(tipoAnalise !== TIPO_ANALISE.UsoVirgula && 
                            tipoAnalise !== TIPO_ANALISE.VozPassiva && 
                            tipoAnalise !== TIPO_ANALISE.Gramatica) && ' ' + tipoAnalise + '...'}
                    </Typography>
                </Box>
            } */}
        </>
    );
}

export default CarregamentoAnalise;